export default __webpack_public_path__ + "static/break-bbecbfe6ada477db92a5303da4b158ea.png";